export default __webpack_public_path__ + "static/inside-bg-1-1afd271e52fbac94b770467ca2e19922.jpg";